import * as React from 'react';
import { Router, Route, hashHistory } from 'react-router';
import { ProtectionPopup } from './ProtectionPopup';

export const ProtectionPopupApp = () => (
  <div className="ProtectionPopupApp">
    <Router history={hashHistory}>
      <Route path="/(:status)" component={ProtectionPopup} />
    </Router>
  </div>
);
